export default {
  adherentsCorrespondant: {
    search: {
      actif: 'Active',
      nom: 'Last name',
      prenom: 'First name',
      idParticipant: 'User ID',
    },
  },
  adherents: {
    overview: 'Detail of a member',
    search: {
      actif: 'Active',
    },
    list: {
      title: 'Members',
      headers: {
        id: 'User ID',
        civilite: 'Civility',
        name: 'Last and First name',
        dateDeNaissance: 'Date of Birth',
        mail: 'E-mail',
        mutation: 'Mutation ?',
        bilan: 'Ongoing health check-up',
      },
    },
  },
  extraciem: {
    participant: {
      bloque:
        'Please try the modification later, the file is currently blocked by the ESSENCIEM system for modification and / or consultation',
    },
  },
  participant: {
    notfound: 'The member was not found',
    readherer: 'Join the member to the company',
    resilier: 'Dismiss the member',
    muter: {
      action: 'Mutate',
      title: 'Transer of the member',
      message: 'Are you sure you want to transfer the member? ?',
      etablissementDestination: 'Destination company',
      priseEnChargeBilanEnCours:
        'Support for the current health check-up By the destination company?',
    },
    details: {
      id: 'Id',
      afterCreation: 'After creation',
      fermerFenetre: 'Close the window',
      nom: 'Last name',
      prenom: 'First name',
      name: 'Member',
      nomJeuneFille: 'Birth name',
      nomPhonetique: 'Phonetic name',
      genre: {
        label: 'gender',
        male: 'Male',
        female: 'Female',
      },
      dateDeNaissance: 'Born the',
      lieuNaissance: 'at',
      dateEcheance: 'Due date',
      status: {
        actif: 'Active',
        inactif: 'Inactive',
      },
      profession: 'Profession',
      fonction: 'Function',
      numTelephone: 'Phone number',
      gsm: 'Cellphone number',
      mail: 'E-mail',
      adresse: 'Address',
      pays: 'Country of practice',
      provenance: 'Origin',
      codePostal: 'Postal code',
      birthDate: 'Born the: ',
      etablissementLabel: 'Company',
      etablissementId: 'Company number',
      etablissementRaisonSociale: 'Social reason of the company',
      categorie: 'Category',
      expirationDate: 'Due date',
      bilanCounter: 'Number of health check-up carried out',
      dateAdhesion: 'Subscription date',
      dateResiliation: 'Termination date',
      datePremiereAdhesion: 'First subscription',
      civilite: 'Civility',
      coordonnee: 'Contact information',
      contact: 'Contact',
      telFixe: 'Phone',
      telPortable: 'Cellphone',
      telSecretariat: 'Phone. Secretariat',
      passerParAssistante: 'Go through the assistant',
      parleQueAnglais: 'English only',
      gestionnaire: {
        message:
          'To modify the inactive information, please contact: <br>{0} <br>By phone at: {1} <br>By E-mail: {2} ',
        partelephone: 'By phone: ',
        parmail: 'By E-mail: ',
      },
      gesRDV: 'Appointment management',
      typeBilan: 'Usual health check-up',
      dateProchainBilan: 'Date of the next health check-up',
      periodiciteBilan: 'Periodicity of health check-up',
    },
    rendezvous: {
      debut: 'Start of the appointment',
      fin: 'End of the appointment',
      ajouter: 'Add',
      objet: 'Type of visit',
      cardiologue: 'Cardiologist',
      interniste: 'Internist',
      gynecologue: 'Gynecologist',
      statut: 'Visit status',
      bilanEnCours: 'health check-up In progress',
    },
    resiliation: {
      motif: 'Reason for delisting',
      resilie: 'The member has been deregistered',
      bilanEC: 'Error: The member has an ongoing healt check-up',
      bilanECTitle: 'Members with an ongoing health check-up',
      bilansEC:
        'Impossible operation: one or more members have an ongoing health check-up. Do you want to display the list?',
      error: 'Error has been occured during deregistration',
      saisieMotifResiliation: 'Enter the reason for termination',
    },
    error: {
      bilan: {
        encours:
          'You cannot deregister this member because he has an ongoing health check-up',
      },
      readherer: {
        doublons:
          'You cannot re-enroll this member, there is another member with the same information, please contact the CIEM',
      },
      muter: {
        etablissementDestinataireIdentique:
          'Error: Destination company is the same as destination company',
        demandeEnCours: 'There is already a mutation in progress',
      },
    },
    readhesion: {
      success: 'The member has been successfully re-enrolled',
    },
    extraciem: {
      bloque:
        'Please try the modification later, the file is currently blocked by the ESSENCIEM system for modification and / or consultation',
    },
    update: {
      success: 'Update successfully completed',
    },
    create: {
      doublons:
        'You cannot create this member, there is another member with the same information, please contact',
      success: 'The member has been successfully created',
      correspondant: {
        notfound: 'The correspondant was not found',
        entrepiseNotfound:
          'The company belonging to the correspondent carrying out the creation was not found',
        error:
          'A technical error occurred during the creation of the member. Please contact support for more information',
      },
    },
    bilanEnCours: 'Ongoing health check-up',
    alertContact: 'The mobile number you entered does not correct',
    alertTypeBilan:
      'You cannot update this health check-up type because the member has an ongoing health check-up, please contact the CIEM',
    attention: 'Warning',
    demandeMutationEnCours: 'Transfer request in progress',
    coordonneesperso: {
      update: {
        error: 'An error occured wile updating personnal details',
      },
    },
    alertDeconnexion:
      'Your login information has changed, please loggin again.',
  },
  adresse: {
    saisie: 'Entering address',
    ligne1: {
      particulier: {
        label: 'Recipient',
        placeholder: 'Civility or title / First name / Last name',
      },
      etablissement: {
        label: 'Company name or commercial name',
      },
    },
    ligne2: {
      particulier: {
        label: 'Pick up point',
        placeholder:
          'Apartment or letter box number / Floor / Corridor / Staircase',
      },
      etablissement: {
        label: 'Recipient or service',
        placeholder: 'Identity of recipient or service',
      },
    },
    ligne3: {
      label: 'Localization supplement',
      particulier: {
        placeholder: 'Building / Residence',
      },
      etablissement: {
        placeholder: 'Building / Residence / Industrial zone',
      },
    },
    numeroVoie: 'No. street',
    typeVoie: 'Type of the street',
    nomVoie: 'Street name',
    ligne5: {
      label: 'Distribution service / Track location supplement',
      particulier: {
        placeholder: 'Poste restante / BP / Lieu-dit',
      },
      etablissement: {
        placeholder: 'BP / TSA',
      },
    },
    codePostal: 'Postal code',
    localite: {
      particulier: 'Locality',
      etablissement: 'Locality and Cedex',
    },
    pays: 'Country',
  },
}
